import { useCallback, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Button from "../../components/Widgets/Button"
import { findAll } from "../../services/blog"
import { dummyPosts } from "../../utilities/post"
import { PostSkeleton } from "../Widgets/CustomSkeleton"
import PostCard from "../Widgets/PostCard"

const RecentPost = () => {
	const [posts, setPosts] = useState(dummyPosts)
	const [isLoading, setIsLoading] = useState(true);

	const getPosts = useCallback(async () => {
		setIsLoading(true);
		const res = await findAll()
		if (res[0]) {
			setPosts(res);
			setIsLoading(false);
		} else {
			setTimeout(() => {
				getPosts();
			}, 2000);
		}
	}, [],)

	useEffect(() => {
		getPosts()
	}, [getPosts])

	return (
		<section id="recentPost" className="dark:bg-slate-900 py-10 app-x">
			<div className="flex justify-between items-center py-5 flex-wrap">
				<h3 className='font-serif text-slate-700 mr-3 font-extrabold dark:text-white text-2xl'>
					<span>Recent Posts</span>
				</h3>
				<Link to={"/blog/all"} className="focused rounded dark:text-slate-300 text-sm flex items-center group">
					<span className="underline">All Posts</span>
					<i className="bx bx-right-arrow-alt -rotate-45 group-hover:rotate-0 transition"></i>
				</Link>
			</div>
			<div className="grid gap-10 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
				{posts.map((each, i) => (
					isLoading ? <PostSkeleton key={i} /> :
						<PostCard data={each} responsive key={i} />
				))}
			</div>
			<Button isLink to={"/blog/all"} className="mx-auto my-10 w-fit" primary>
				<i className='bx bx-grid'></i>
				<span>View all posts</span>
			</Button>
		</section >
	)
}

export default RecentPost